<template>
  <nav class="navbar" v-bind:class="{'is-fixed-top': fix, 'is-spaced': !isAdminUi, 'is-admin': isAdminUi}" role="navigation" aria-label="main navigation">
    <div  class="navbar-brand">
      <a v-if="!isAdminUi" class="navbar-item brand" href="/">
        <img src="/logo-black.png" alt="logo" class="logo-img"> FeedLetter
      </a>

<a role="button" class="navbar-burger" v-bind:class='{"is-active": burgerActive}' data-target="navMenu" aria-label="menu" aria-expanded="false" @click="toggleBurger">
  <span aria-hidden="true"></span>
  <span aria-hidden="true"></span>
  <span aria-hidden="true"></span>
</a>
      
    </div>
    <div class="navbar-menu" v-bind:class='{"is-active": burgerActive}'>
    <div v-if="user.isLoggedIn" class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class=" navbar-link ">{{account.name}}</a>

          <div class="navbar-dropdown is-left">
            <a v-for="acc in availableAccounts" :key="'r' + acc.id" class="navbar-item" @click="selectAccount(acc.id)">{{acc.name}}</a>
            <a class="navbar-item" href="/account/create">Create new Account</a>
          </div>
        </div>

        <div  class="navbar-item">
          <a class="button  is-primary " v-bind:class="{'is-inverted': activeMenu == 'dashboard', 'is-outlined': activeMenu != 'dashboard'}" href="/dashboard">Dashboard</a>
        </div>
        <div  class="navbar-item">
          <a class="button  is-primary" v-bind:class="{'is-inverted': activeMenu == 'newnlform', 'is-outlined': activeMenu != 'newnlform'}" href="/feedback/create">Create Newsletter Survey</a>
        </div>        
    </div>

  <div class="navbar-end">
    <a class="navbar-item" href="/walloflove">Wall of Love</a>
    <a class="navbar-item" href="/upgrade">Pricing</a>
    <a class="navbar-item" href="/casestudies/">Case Studies</a>
    <a class="navbar-item" href="/blog/">Blog</a>
      <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Help
          </a>

          <div class="navbar-dropdown is-right">
            <a class="navbar-item" href="/help/">Help Pages</a>
            <a class="navbar-item" href="/faq">FAQ</a>
            <a class="navbar-item" href="/tags/tips">Tips</a>
            <a class="navbar-item" href="/casestudies/">Case Studies</a>
            <a class="navbar-item" href="/changelog">Product Updates</a>
            <hr class="navbar-divider">
            <a class="navbar-item" href="mailto:hello@feedletter.co" target="_blank">
              Questions? Email me
            </a>
            
          </div>
        </div>

        <a v-if="!user.isLoggedIn" class="navbar-item" href="/login">Login</a>
        <div v-if="!user.isLoggedIn" class="navbar-item">
                <a class="button is-primary" href="/register">Create Survey</a>
        </div>

        <div v-else class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            My Account
          </a>

          <div class="navbar-dropdown is-right">
            <a v-if="user.isLoggedIn" class="navbar-item" href="/account">Account Settings</a>
            <hr class="navbar-divider">
            <a  class="navbar-item" href="/changepassword">Change Password</a>
            <a class="navbar-item" @click.prevent="logout">
              Log Out
            </a>
          </div>
        </div>
    
  </div>
</div>

  </nav>

 
</template>
<script>
import { mapState } from 'vuex'

export default {
  components: {

  },
  props: {
    fix: {
      type: Boolean,
      default: false
    },
    isAdminUi: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    return {
      burgerActive:false,

    }
  },
  computed: {
    ...mapState([
      "user",
      "account"
    ]),
    activeMenu() {
      return this.$route.meta.activeMenu
    },
    availableAccounts() {
      return this.$store.state.availableAccounts.filter((acc) => acc.id !== this.account.id)
    }
  },
  mounted: function() {

  },
    methods: {
    toggleBurger:function() {
      this.burgerActive = !this.burgerActive
    },
    selectAccount(id) {
      this.$store.dispatch('selectAccount', id).then(() => {
        location.reload()
      })
    },
    logout: function() {
        this.$store.dispatch('logout').then(() => {
          if(!this.$store.getters.error){
            this.$router.push("/")
          }
        })
    },
  },
};
</script>
<style scoped>

.navbar.is-admin2 {
  background-color: #f1f1f1;
}

.brand {
  font-size: 1.6rem;
}
.brand:hover {
  background-color: unset !important;
}

.logo-img {
  margin-right: 1rem;
}
</style>
